export default "__VITE_ASSET__Dfk5sNNs__"